
function staticHeaderOnScroll(){
  if(window.scrollY >= 100){
    document.getElementById("HeaderWrapper").style.position = "fixed";
    document.getElementById("HeaderWrapper").style.width = "100%" 
      document.getElementById("HeaderWrapper").style.top = "0"  
    document.getElementById("HeaderWrapper").classList.add("header-wrapper--compressed")
  }else{
    document.getElementById("HeaderWrapper").style.position = "inherit";
    document.getElementById("HeaderWrapper").style.width = "100%" 
    document.getElementById("HeaderWrapper").classList.remove("header-wrapper--compressed")

  }
  }

window.addEventListener("scroll",staticHeaderOnScroll)
